import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type RolePermissionAction = {
  id: number;
  action_name: string;
  display_name: string;
};

export type RolePermissionModule = {
  id: number;
  module_name: string;
  display_name: string;
  tool_tip: string;
  description: string;
  path: string | null;
  element_name: string | null;
  sequence: number;
  actions: RolePermissionAction[];
};

export type RolePermissionRole = {
  id: number;
  name: string;
  display_name: string;
  modules: RolePermissionModule[];
};

export type RolePermissionResponse = {
  status: boolean;
  message: string;
  status_code: number;
  data: {
    roles: RolePermissionRole[];
  };
};

export type RolePermissionState = {
  response: RolePermissionResponse | null;
};

const initialState: RolePermissionState = {
  response: null,
};

const rolePermissionSlice = createSlice({
  name: "rolePermission",
  initialState,
  reducers: {
    setRolePermission: (state, action: PayloadAction<RolePermissionResponse>) => {
      state.response = action.payload;
    },
  },
});

export const { setRolePermission } = rolePermissionSlice.actions;
export default rolePermissionSlice.reducer;
